/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useState } from "react";
import MainBody from "../../components/MainBody/MainBody";
import { useLocation, useNavigate } from "react-router-dom";
import {
  API,
  defaultLimitPagination,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "../../components/Pagination";
import {
  ExGSTClaculate,
  formatNumber,
  formatSubcontractorName,
  getModuleNamingBySlug,
  padWithLeadingZeros,
} from "../../lib/Misc";
import CustomTooltip from "../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { debounce } from "lodash";
// import ExpandJournalEntry from "./ExpandJournalEntry";
import sortCaret from "../../components/SortCaret";
// import { CaretDownIcon, CaretRightIcon } from "@radix-ui/react-icons";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import CommonFilters from "../../components/CommonFilters";
import { useTrust } from "../../lib/context/TrustContext";
import { useOrganization } from "../../lib/context/OrganisationContext";
import { cn } from "../../lib/utils";

const JournalEntries = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const search = query.get("search");
  const { organizationData } = useOrganization();

  const [journalEntryList, setJournalEntryList] = useState(null);
  const [journalEntryData, setJournalEntryData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const { trustId } = useTrust();

  const [vendorId, setVendorId] = useState();
  const [assetId, setAssetId] = useState();
  const [contactId, setContactId] = useState();
  const [subAssetId, setSubAssetId] = useState();

  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");

  // const [expandedRow, setExpandedRow] = useState([]);
  const [show, setShow] = useState(false);
  const [detailsData, setDetailsData] = useState({});

  const toggleShowModal = (data) => {
    setShow(true);
    setDetailsData(data);
  };

  const fetchJournalEntries = useCallback(
    async (passLimit, passPage) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.JOURNAL_ENTRIES}?trust_id=${trustId}&limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&search=${
            searchParam ? searchParam : ""
          }&sort_column=${sortField ? sortField : ""}&sort_order=${
            sortOrder ? sortOrder : ""
          }&vendor_id=${vendorId ? vendorId : ""}&contact_id=${
            contactId ? contactId : ""
          }&asset_id=${assetId ? assetId : ""}&sub_asset_id=${
            subAssetId ? subAssetId : ""
          }`
        );
        setLoading(false);
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        const journalEntryList = data.data.data;
        // let expanded = [];
        // for (let i = 0; i < journalEntryList?.length; i++) {
        //   expanded.push(journalEntryList[i]?.id);
        // }
        // setExpandedRow(expanded);
        setJournalEntryList(journalEntryList);
        return data.data;
      } catch (error) {
        setLoading(false);
        setJournalEntryList([]);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      assetId,
      contactId,
      searchParam,
      sortField,
      sortOrder,
      subAssetId,
      trustId,
      vendorId,
    ]
  );

  useEffect(() => {
    navigate(
      `?limit=${limit ? limit : defaultLimitPagination}&page=${
        page ? page : 1
      }&search=${searchParam ? searchParam : ""}&sort_column=${
        sortField ? sortField : ""
      }&sort_order=${sortOrder ? sortOrder : ""}`,
      {
        replace: true,
      }
    );
  }, [navigate, limit, searchParam, page, sortField, sortOrder]);

  useEffect(() => {
    fetchJournalEntries();
  }, [fetchJournalEntries]);

  /**
   * Vendors Limit Per Page
   */
  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchJournalEntries(limit, 1);
  };

  /**
   * Pagination
   */
  const handleChangePage = (page) => {
    setPage(page);
    fetchJournalEntries(limit, page);
  };

  /**
   * Table Change For Sorting
   */
  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC"
      );
    }
  };
  const journalEntryGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: journalEntryList[i]?.id,
        transaction_date: journalEntryList[i]?.transaction_date
          ? journalEntryList[i]?.transaction_date
          : "",
        approved_date: journalEntryList[i]?.approved_date
          ? journalEntryList[i]?.approved_date
          : "-",
        period: journalEntryList[i]?.period ? journalEntryList[i]?.period : "-",
        batch_id: journalEntryList[i]?.batch_id
          ? journalEntryList[i]?.batch_id
          : "-",
        reference_number: journalEntryList[i]?.reference_number
          ? journalEntryList[i]?.reference_number
          : "-",

        source: `${
          journalEntryList[i]?.receipt_id
            ? "Receipt"
            : journalEntryList[i]?.payment_id
            ? "Payments"
            : String(
                journalEntryList[i]?.journal_entry_details[0]
                  ?.transaction_reference_number
              ).includes("(JE)")
            ? "Journal Entries"
            : "-"
        } ${
          journalEntryList[i]?.is_disposed
            ? " - Disposed"
            : journalEntryList[i]?.archived
            ? " - Revert"
            : journalEntryList[i]?.is_reversed
            ? " - Reversed"
            : journalEntryList[i]?.is_refund
            ? journalEntryList[i]?.allocated
              ? " - Allocation By Journal Entry"
              : journalEntryList[i]?.receipt_id
              ? journalEntryList[i]?.refundable
                ? " - Refundable"
                : " - Refunded"
              : journalEntryList[i]?.payment_id
              ? " - Refunded"
              : ""
            : ""
        }`,
        amount: journalEntryList[i]?.total_amount
          ? `$${formatNumber(Number(journalEntryList[i]?.total_amount))}`
          : "-",
        gst_amount: journalEntryList[i]?.gst_amount
          ? `$${formatNumber(Number(journalEntryList[i]?.gst_amount))}`
          : "-",
        net_amount: journalEntryList[i]?.net_amount
          ? `$${formatNumber(Number(journalEntryList[i]?.net_amount))}`
          : "-",
        journal_entry_details: journalEntryList[i]?.journal_entry_details,
        is_reversed: journalEntryList[i]?.is_reversed,
        is_refund: journalEntryList[i]?.is_refund,
        archived: journalEntryList[i]?.archived,
        is_disposed: journalEntryList[i]?.is_disposed,
        action: (
          <>
            <CustomTooltip message={"View"}>
              <span>
                <FontAwesomeIcon
                  onClick={() => {
                    toggleShowModal(journalEntryList[i]);
                    // fetchJournalEntryData(journalEntryList[i].id);
                    setJournalEntryData(
                      journalEntryList[i]?.journal_entry_details
                    );
                  }}
                  icon={faEye}
                  size="1x"
                  data-toggle="modal"
                  data-target="#businessDetail"
                />
              </span>
            </CustomTooltip>
          </>
        ),
      });
    }
    return items;
  };
  const journalEntries = journalEntryGenerator(journalEntryList?.length);

  /**
   * Table Heading Data
   */
  const columns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "transaction_date",
      text: "Transaction Date",
      sort: true,
      sortCaret,
    },
    // {
    //   headerClasses: THClasses,
    //   classes: TDClasses,
    //   dataField: "approved_date",
    //   text: "Approval Date",
    //   sort: true,
    //   sortCaret,
    // },

    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "batch_id",
      text: "Batch Id ",
      sort: true,
      sortCaret,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "reference_number",
      text: "Reference/ID",
      sort: true,
      sortCaret,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "source",
      text: "Source",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "amount",
      text: "Total Amount",
    },

    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "action",
      text: "Details",
      align: "center",
      headerStyle: {
        textAlign: "center",
      },
    },
  ];

  // const expandRow = {
  //   renderer: (row) => (
  //     <>
  //       <ExpandJournalEntry
  //         id={row?.key}
  //         trustId={trustId}
  //         expandJournalData={row?.journal_entry_details}
  //         is_reversed={row?.is_reversed}
  //       />
  //     </>
  //   ),
  //   expanded: expandedRow,
  //   onlyOneExpanding: false,
  //   showExpandColumn: true,
  //   expandByColumnOnly: true,
  //   headerClasses: THClasses,
  //   expandColumnRenderer: ({ expanded }) => {
  //     if (expanded) {
  //       return <CaretDownIcon />;
  //     }
  //     return <CaretRightIcon />;
  //   },
  //   className: TDClasses,
  //   expandHeaderColumnRenderer: () => {
  //     return <></>;
  //   },
  // };

  const viewJournalDataGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: journalEntryData[i]?.id,
        transaction_date: detailsData?.transaction_date
          ? detailsData?.transaction_date
          : "",
        account: journalEntryData[i]?.chart_of_account
          ? (journalEntryData[i]?.chart_of_account?.code?.length < 4
              ? padWithLeadingZeros(
                  Number(journalEntryData[i]?.chart_of_account?.code),
                  4
                )
              : journalEntryData[i]?.chart_of_account?.code.toString()) +
            (journalEntryData[i]?.chart_of_account?.sub_code
              ? "." + journalEntryData[i]?.chart_of_account?.sub_code.toString()
              : "") +
            " - " +
            journalEntryData[i]?.chart_of_account?.name
          : "",

        contact: journalEntryData[i]?.contact
          ? `${formatSubcontractorName(
              journalEntryData[i]?.contact
            )} - (${getModuleNamingBySlug(
              organizationData?.organizationData,
              "contacts",
              "C"
            )?.charAt(0)})`
          : journalEntryData[i]?.vendor
          ? `${formatSubcontractorName(
              journalEntryData[i]?.vendor
            )} - (${getModuleNamingBySlug(
              organizationData?.organizationData,
              "vendors",
              "V"
            )?.charAt(0)})`
          : journalEntryData[i]?.trust
          ? journalEntryData[i]?.trust?.business_name
            ? journalEntryData[i]?.trust?.business_name
            : journalEntryData[i]?.trust?.first_name
            ? journalEntryData[i]?.trust?.first_name +
              " " +
              journalEntryData[i]?.trust?.last_name
            : journalEntryData[i]?.trust?.last_name
          : "-",
        debit:
          journalEntryData[i]?.transaction_type === 0
            ? journalEntryData[i]?.amount
              ? "$" + formatNumber(Number(journalEntryData[i]?.amount))
              : "$0.00"
            : "-",
        credit:
          journalEntryData[i]?.transaction_type === 1
            ? journalEntryData[i]?.amount
              ? "$" + formatNumber(Number(journalEntryData[i]?.amount))
              : "$0.00"
            : "-",
        gst:
          journalEntryData[i]?.gst === 0
            ? "GST Excluded"
            : journalEntryData[i]?.gst === 1
            ? "GST 10%"
            : journalEntryData[i]?.gst === 2
            ? "BAS Excluded"
            : "GST on Imports",
        tax: journalEntryData[i]?.gst_amount
          ? "$" + formatNumber(Number(journalEntryData[i]?.gst_amount))
          : "-",
        ex_gst_amount: journalEntryData[i]?.amount
          ? "$" +
            ExGSTClaculate(
              journalEntryData[i]?.amount,
              journalEntryData[i]?.gst
            )
          : 0,
        description: journalEntryData[i]?.description
          ? journalEntryData[i]?.description
          : "-",
      });
    }
    return items;
  };
  const viewJournalData = viewJournalDataGenerator(journalEntryData?.length);

  const viewColumns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "transaction_date",
      text: "Transaction Date ",
    },
    {
      headerClasses: cn(
        THClasses,
        "whitespace-normal break-words" // fixed width + wrapping
      ),
      classes: cn(
        TDClasses,
        "whitespace-normal break-words" // fixed width + wrapping
      ),
      dataField: "contact",
      text: "Contact ",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "account",
      text: "Account",
    },

    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "debit",
      text: "Debit",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "credit",
      text: "Credit",
    },

    {
      headerClasses: cn(
        THClasses,
        "whitespace-normal break-words" // fixed width + wrapping
      ),
      classes: cn(
        TDClasses,
        "whitespace-normal break-words" // fixed width + wrapping
      ),
      dataField: "description",
      text: "Description",
    },
  ];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    []
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    debouncedSave(nextValue);
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  return (
    <>
      <MainBody
        searchParamData={searchParamData}
        handleClearSearch={handleClearSearch}
        handleSearchChange={handleSearchChange}
        actionContent={
          <>
            <CommonFilters
              trustId={trustId}
              contact={true}
              setContactId={setContactId}
              contactId={contactId}
              vendor={true}
              setVendorId={setVendorId}
              vendorId={vendorId}
              asset={true}
              setAssetId={setAssetId}
              assetId={assetId}
              subAsset={true}
              setSubAssetId={setSubAssetId}
              subAssetId={subAssetId}
            />
          </>
        }
        loading={loading}
      >
        <div className="custom-table">
          <div className={"table-body-class"}>
            <BootstrapTable
              keyField="key"
              remote
              data={journalEntries || []}
              columns={columns}
              // expandRow={expandRow}
              onTableChange={handleTableChange}
              rowClasses={(row) => {
                if (row?.is_reversed) {
                  return `${TRClasses} bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50`;
                }
                if (row?.is_refund) {
                  return `${TRClasses} bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50`;
                }
                if (row?.archived) {
                  return `${TRClasses} bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50`;
                }
                if (row?.is_disposed) {
                  return `${TRClasses} bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50`;
                }
                return TRClasses;
              }}
              noDataIndication="No Data Found"
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>

          <Pagination
            total={total}
            limit={parseInt(limit)}
            currentPage={page}
            updateLimit={handleUpdateLimit}
            updatePage={handleChangePage}
            from={from}
            to={to}
          />
        </div>
      </MainBody>
      <ResponsiveDrawerForm
        description={""}
        title={"Journal Entry Details"}
        handleOpen={() => {}}
        handleClose={() => {}}
        className={"md:w-[65vw]"}
        open={show}
        buttonClassName={""}
        setOpen={setShow}
        read={true}
      >
        <div className={"table-body-class"}>
          <BootstrapTable
            keyField="key"
            remote
            data={viewJournalData || []}
            columns={viewColumns}
            rowClasses={TRClasses}
            noDataIndication="No Data Found"
            classes={TableClasses}
            wrapperClasses={TableWrapClasses}
          />
        </div>
      </ResponsiveDrawerForm>
    </>
  );
};

export default JournalEntries;
